import React, { useEffect, useState } from 'react';
import { FaArrowLeft } from 'react-icons/fa6';
import { useParams, useNavigate } from 'react-router-dom';

import SubAbasTasks from './subabasTasks';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomCol from '../../../../components/CustomCol';
import CustomRow from '../../../../components/CustomRow';
import Input from '../../../../components/InputNew';
import SelectInput from '../../../../components/InputNew/Select';
import StyledLink from '../../../../components/Link';
import Log from '../../../../components/Log/Log';
import SubAbas from '../../../../components/SubAbas';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../components/WorkspaceFicha';
import { getUser } from '../../../../modules/contexts/Auth/RequireAuth';
import { useInterfaceSisaf } from '../../../../services/enum/useInterfaceSisaf';
import { useModuloDaf } from '../../../../services/enum/useModuloDaf';
import { useResponsavelTask } from '../../../../services/enum/useResponsavelTask';
import { useTipoTask } from '../../../../services/enum/useTipoTask';
import { getTaskSisaf } from '../../../../services/gestaoSisAF/tasksSisAfService';
import httpClient, { isHttpError } from '../../../../services/httpClient';
import { formataNomeMeioSiglas } from '../../../../utils/functions';
import {
  swal,
  swalAtualizacao,
  swalSave,
  swalErro,
  swalDelete,
  swalDeleteConfirm,
  swalAttention,
} from '../../../../utils/swal';

export default function TasksFicha() {
  //Dados do usuário
  const user = getUser();
  const userID = user.sub;
  const navigate = useNavigate();
  const params = useParams();
  const fichaID = String(params.id);

  //Dados do componente
  let logs = {};
  let subAbas = [];

  const interfaceSisaf = useInterfaceSisaf();
  const moduloDaf = useModuloDaf();
  const responsavelTask = useResponsavelTask();
  const tipoTask = useTipoTask();

  const valoresZeroDez = [
    { value: 0, label: 'Não informado' },
    { value: 1, label: '1 - Muito simples' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
    { value: 5, label: '5' },
    { value: 6, label: '6' },
    { value: 7, label: '7' },
    { value: 8, label: '8' },
    { value: 9, label: '9' },
    { value: 10, label: '10 - Muito complexo' },
  ];

  const valoresZeroDezStatus = [
    { value: 0, label: 'Não informado' },
    { value: 1, label: '0% - Não iniciado' },
    { value: 2, label: '10%' },
    { value: 3, label: '20%' },
    { value: 4, label: '30%' },
    { value: 5, label: '40%' },
    { value: 6, label: '50%' },
    { value: 7, label: '60%' },
    { value: 8, label: '70%' },
    { value: 9, label: '80%' },
    { value: 10, label: '90%' },
    { value: 11, label: '100% - Finalizado' },
  ];

  const valoresZeroDezReaproveitamentoCodigo = [
    { value: 0, label: 'Não informado' },
    { value: 1, label: '1 - Sim, completamente' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
    { value: 4, label: '4' },
    { value: 5, label: '5' },
    { value: 6, label: '6' },
    { value: 7, label: '7' },
    { value: 8, label: '8' },
    { value: 9, label: '9' },
    { value: 10, label: '10 - Não, nada' },
  ];

  const [logData, setLogData] = useState({
    id: '',
    usuarioRegistro: {
      nomeCompleto: '',
    },
    usuarioAtualizacao: {
      nomeCompleto: '',
    },
    dataRegistro: '',
    dataUltimaAtualizacao: '',
    dataUltimaVisualizacao: '',
    nEdicoes: '',
    nVisualizacoes: '',
    nVisualizadores: '',
  });

  const [formTask, setFormTask] = useState({
    usuarioId: userID,
    interfaceSisAf: 0,
    moduloSisAf: 0,
    tipoTask: 0,
    responsavel: 0,
    dataEntrada: '',
    dataFinalizacao: '',
    funcionalidade: '',
    descricao: '',
    complexidade: '',
    reaproveitamentoCodigo: '',
    statusDesenvolvimento: '',
    pontosFuncionalidade: 0,
    pontosDesenvolvidos: 0,
    observacoes: '',
  });

  //Buscar dados
  const fetchData = async (id: string) => {
    try {
      const registroData = await getTaskSisaf(id);
      setLogData(registroData);

      const dataEntrada = registroData.dataEntrada
        ? new Date(registroData.dataEntrada).toISOString().split('T')[0]
        : '';

      const dataFinalizacao = registroData.dataFinalizacao
        ? new Date(registroData.dataFinalizacao).toISOString().split('T')[0]
        : '';

      setFormTask({
        usuarioId: userID,
        interfaceSisAf: registroData.interfaceSisAf,
        moduloSisAf: registroData.moduloSisAf,
        tipoTask: registroData.tipoTask,
        responsavel: registroData.responsavel,
        dataEntrada: dataEntrada,
        dataFinalizacao: dataFinalizacao,
        funcionalidade: registroData.funcionalidade,
        descricao: registroData.descricao,
        complexidade: registroData.complexidade,
        reaproveitamentoCodigo: registroData.reaproveitamentoCodigo,
        statusDesenvolvimento: registroData.statusDesenvolvimento + 1,
        pontosFuncionalidade:
          registroData.complexidade * registroData.reaproveitamentoCodigo,
        pontosDesenvolvidos:
          registroData.complexidade *
          registroData.reaproveitamentoCodigo *
          ((registroData.statusDesenvolvimento - 1) * 0.1),
        observacoes: registroData.observacoes,
      });
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };

  //Nível de Complexidade
  const [nivelComplexidadeStyle, setNivelComplexidadeStyle] =
    useState<React.CSSProperties>({});

  useEffect(() => {
    // Definindo as cores base
    const vermelhoClaro = [255, 234, 234]; // RGB para vermelho claro
    const vermelhoEscuro = [200, 0, 0]; // RGB para vermelho escuro

    const complexidade = Number(formTask.complexidade);

    // Se a complexidade não for informada (0)
    if (complexidade === 0) {
      setNivelComplexidadeStyle({ backgroundColor: '#ffffff' }); // Branco
      return;
    }

    // Calcular interpolação entre vermelho claro e vermelho escuro
    const interpolacao = (complexidade - 1) / 10; // Ajuste de 1 a 10

    const r = Math.round(
      vermelhoClaro[0] + (vermelhoEscuro[0] - vermelhoClaro[0]) * interpolacao,
    );
    const g = Math.round(
      vermelhoClaro[1] + (vermelhoEscuro[1] - vermelhoClaro[1]) * interpolacao,
    );
    const b = Math.round(
      vermelhoClaro[2] + (vermelhoEscuro[2] - vermelhoClaro[2]) * interpolacao,
    );

    const newComplexidade: React.CSSProperties = {
      backgroundColor: `rgb(${r}, ${g}, ${b})`,
      color: complexidade > 4 ? '#ffffff' : '#000000', // Fonte branca se complexidade > 5, caso contrário preta
    };

    setNivelComplexidadeStyle(newComplexidade);
  }, [formTask.complexidade]);

  //Reaproveitamento de Código
  const [reaproveitamentoStyle, setReaproveitamentoStyle] =
    useState<React.CSSProperties>({});

  useEffect(() => {
    // Definindo as cores base
    const vermelhoClaro = [255, 234, 234]; // RGB para vermelho claro
    const vermelhoEscuro = [200, 0, 0]; // RGB para vermelho escuro

    const reproveitamento = Number(formTask.reaproveitamentoCodigo);

    // Se a complexidade não for informada (0)
    if (reproveitamento === 0) {
      setReaproveitamentoStyle({ backgroundColor: '#ffffff' }); // Branco
      return;
    }

    // Calcular interpolação entre vermelho claro e vermelho escuro
    const interpolacao = (reproveitamento - 1) / 10; // Ajuste de 1 a 10

    const r = Math.round(
      vermelhoClaro[0] + (vermelhoEscuro[0] - vermelhoClaro[0]) * interpolacao,
    );
    const g = Math.round(
      vermelhoClaro[1] + (vermelhoEscuro[1] - vermelhoClaro[1]) * interpolacao,
    );
    const b = Math.round(
      vermelhoClaro[2] + (vermelhoEscuro[2] - vermelhoClaro[2]) * interpolacao,
    );

    const newReaproveitamento: React.CSSProperties = {
      backgroundColor: `rgb(${r}, ${g}, ${b})`,
      color: reproveitamento > 4 ? '#ffffff' : '#000000', // Fonte branca se complexidade > 5, caso contrário preta
    };

    setReaproveitamentoStyle(newReaproveitamento);
  }, [formTask.reaproveitamentoCodigo]);

  //Level
  const [levelStyle, setLevelStyle] = useState<React.CSSProperties>({});

  useEffect(() => {
    // Definindo as cores base
    const vermelhoClaro = [255, 234, 234]; // RGB para vermelho claro
    const vermelhoEscuro = [200, 0, 0]; // RGB para vermelho escuro

    const level = Number(formTask.pontosFuncionalidade);

    // Se a complexidade não for informada (0)
    if (level === 0) {
      setLevelStyle({ backgroundColor: '#ffffff' }); // Branco
      return;
    }

    // Calcular interpolação entre vermelho claro e vermelho escuro
    const interpolacao = (level - 1) / 100; // Ajuste de 1 a 100

    const r = Math.round(
      vermelhoClaro[0] + (vermelhoEscuro[0] - vermelhoClaro[0]) * interpolacao,
    );
    const g = Math.round(
      vermelhoClaro[1] + (vermelhoEscuro[1] - vermelhoClaro[1]) * interpolacao,
    );
    const b = Math.round(
      vermelhoClaro[2] + (vermelhoEscuro[2] - vermelhoClaro[2]) * interpolacao,
    );

    const newLevel: React.CSSProperties = {
      backgroundColor: `rgb(${r}, ${g}, ${b})`,
      color: level > 40 ? '#ffffff' : '#000000', // Fonte branca se complexidade > 5, caso contrário preta
    };

    setLevelStyle(newLevel);
  }, [formTask.pontosFuncionalidade]);

  //Status Desenvolvimento
  const [statusDesenvolvimentoStyle, setStatusDesenvolvimentoStyle] =
    useState<React.CSSProperties>({});

  useEffect(() => {
    // Definindo as cores base
    const vermelho = [230, 100, 100]; // RGB para vermelho
    const amarelo = [255, 255, 0]; // RGB para amarelo
    const verde = [0, 210, 0]; // RGB para verde

    const statusDev = Number(formTask.statusDesenvolvimento);

    // Se o status não for informado (0)
    if (statusDev === 0) {
      setStatusDesenvolvimentoStyle({ backgroundColor: '#ffffff' }); // Branco
      return;
    }

    let r, g, b;

    if (statusDev <= 6) {
      // Interpolar entre vermelho e amarelo (status de 1 a 5)
      const interpolacao = (statusDev - 1) / 5; // De 1 a 5

      r = Math.round(vermelho[0] + (amarelo[0] - vermelho[0]) * interpolacao);
      g = Math.round(vermelho[1] + (amarelo[1] - vermelho[1]) * interpolacao);
      b = Math.round(vermelho[2] + (amarelo[2] - vermelho[2]) * interpolacao);
    } else {
      // Interpolar entre amarelo e verde (status de 6 a 10)
      const interpolacao = (statusDev - 6) / 4; // De 5 a 10

      r = Math.round(amarelo[0] + (verde[0] - amarelo[0]) * interpolacao);
      g = Math.round(amarelo[1] + (verde[1] - amarelo[1]) * interpolacao);
      b = Math.round(amarelo[2] + (verde[2] - amarelo[2]) * interpolacao);
    }

    const newStatus: React.CSSProperties = {
      backgroundColor: `rgb(${r}, ${g}, ${b})`,
      color:
        statusDev == 0
          ? '#00000'
          : statusDev <= 2 || statusDev >= 10
            ? '#ffffff'
            : '#000000',
    };

    setStatusDesenvolvimentoStyle(newStatus);
  }, [formTask.statusDesenvolvimento]);

  const [isDataFimReadOnly, setIsDataFimReadOnnly] = useState(false);
  useEffect(() => {
    if (formTask.statusDesenvolvimento == '11') {
      setIsDataFimReadOnnly(false);
    } else {
      setIsDataFimReadOnnly(true);
      setFormTask((prev) => ({
        ...prev,
        dataFinalizacao: '',
      }));
    }
  }, [formTask.statusDesenvolvimento]);

  //Condicional para verificar se é necessário buscar dados e ajustar subabas
  if (fichaID !== 'undefined') {
    //Buscar dados
    useEffect(() => {
      fetchData(fichaID); // Chama a função para buscar dados quando o comp
    }, []);
    logs = {
      id: logData.id,
      usuarioRegistro: formataNomeMeioSiglas(
        logData.usuarioRegistro.nomeCompleto,
      ),
      usuarioAtualizacao: formataNomeMeioSiglas(
        logData.usuarioAtualizacao.nomeCompleto,
      ),
      dataRegistro: logData.dataRegistro,
      dataAtualizacao: logData.dataUltimaAtualizacao,
      nEdicoes: logData.nEdicoes,
    };

    //Subabas
    subAbas = SubAbasTasks(fichaID);
  } else {
    subAbas = [
      {
        label: 'Dados Gerais',
        rota: `/daf/maisopcoes/tasks/ficha/dadosgerais`,
      },
    ];
  }

  //Funções Handle
  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = event.target;

    // Atualizando o estado do formulário
    setFormTask((prevState) => {
      const updatedForm = {
        ...prevState,
        [name]: value,
      };

      // Verifica se os campos 'reaproveitamentoCodigo' ou 'complexidade' foram alterados
      if (name === 'reaproveitamentoCodigo' || name === 'complexidade') {
        const reaproveitamentoCodigo = Number(
          updatedForm.reaproveitamentoCodigo,
        );
        const complexidade = Number(updatedForm.complexidade);

        // Calcula pontosFuncionalidade apenas se ambos os campos forem válidos
        if (reaproveitamentoCodigo > 0 && complexidade > 0) {
          updatedForm.pontosFuncionalidade =
            reaproveitamentoCodigo * complexidade;
        } else {
          updatedForm.pontosFuncionalidade = 0;
        }
      }

      // Verifica se os campos 'reaproveitamentoCodigo' ou 'complexidade' foram alterados
      if (
        name === 'reaproveitamentoCodigo' ||
        name === 'complexidade' ||
        name === 'statusDesenvolvimento'
      ) {
        const reaproveitamentoCodigo = Number(
          updatedForm.reaproveitamentoCodigo,
        );
        const complexidade = Number(updatedForm.complexidade);
        const status = Number(updatedForm.statusDesenvolvimento);

        // Calcula pontosFuncionalidade apenas se ambos os campos forem válidos
        if (reaproveitamentoCodigo > 0 && complexidade > 0 && status > 0) {
          updatedForm.pontosDesenvolvidos =
            reaproveitamentoCodigo * complexidade * ((status - 1) / 10);
        } else {
          updatedForm.pontosDesenvolvidos = 0;
        }
      }

      return updatedForm;
    });
  };

  const validateForm = (form: any) => {
    const errors: string[] = [];

    // Verificar cada campo
    if (!form.interfaceSisAf) {
      errors.push('<b>Interface do Sisaf</b> é obrigatório.');
    }

    if (!form.moduloSisAf) {
      errors.push('<b>Módulo</b> é obrigatório.');
    }

    if (!form.tipoTask) {
      errors.push('<b>Tipo de Task</b> é obrigatório.');
    }

    // if (!form.dataEntrada) {
    //   errors.push('<b>Data de Início</b> é obrigatório.');
    // }

    if (form.statusDesenvolvimento == '11' && form.dataFinalizacao == '') {
      errors.push('<b>Data Fim</b> é obrigatório.');
    }

    if (form.dataFinalizacao != '') {
      const dataFinalizacao = new Date(form.dataFinalizacao);
      const dataEntrada = new Date(form.dataEntrada);

      if (dataFinalizacao < dataEntrada) {
        errors.push(
          'A <b>Data Fim</b> não pode ser anterior à <b>Data de Início</b>.',
        );
      }
    }

    if (!form.responsavel) {
      errors.push('<b>Responsável</b> é obrigatório.');
    }

    if (!form.funcionalidade) {
      errors.push('<b>Funcionalidade</b> é obrigatório.');
    }

    if (!form.descricao) {
      errors.push('<b>Descrição</b> é obrigatório.');
    }

    if (!form.complexidade) {
      errors.push('<b>Complexidade</b> é obrigatório.');
    }

    if (!form.reaproveitamentoCodigo) {
      errors.push('<b>Reaproveitamento de Código</b> é obrigatório.');
    }

    if (!form.statusDesenvolvimento) {
      errors.push('<b>Status de Desenvolvimento</b> é obrigatório.');
    }

    if (errors.length > 0) {
      swalAttention(errors.join('<br>')); // Exibe todas as mensagens de erro no swal
      return false;
    }

    return true; // Validação bem-sucedida
  };

  const handleCreate = async () => {
    try {
      // Verificar se o formulário é válido
      const isFormValid = validateForm(formTask);
      if (!isFormValid) return;

      const formToSend = {
        ...formTask,
        interfaceSisAf: Number(formTask.interfaceSisAf),
        moduloSisAf: Number(formTask.moduloSisAf),
        tipoTask: Number(formTask.tipoTask),
        responsavel: Number(formTask.responsavel),
        complexidade: Number(formTask.complexidade),
        reaproveitamentoCodigo: Number(formTask.reaproveitamentoCodigo),
        statusDesenvolvimento: Number(formTask.statusDesenvolvimento) - 1,
        dataEntrada: formTask.dataEntrada ? formTask.dataEntrada : null,
        dataFinalizacao: formTask.dataFinalizacao
          ? formTask.dataFinalizacao
          : null,
      };

      // const token = 'JWT_SECRET';

      const response = await httpClient.post(`/api/taskssisdaf/`, formToSend);

      swalSave();
      setTimeout(
        () =>
          (window.location.href = `#/daf/maisopcoes/tasks/ficha/${response.data.registro.id}/dadosgerais`),
        2500,
      );
    } catch (error) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao salvar registro:', error);
      swal('error', 'Erro!', 'Erro ao salvar registro.');
    }
  };

  const handleUpdate = async () => {
    try {
      // Verificar se o formulário é válido
      const isFormValid = validateForm(formTask);
      if (!isFormValid) return;

      const formToSend = {
        ...formTask,
        interfaceSisAf: Number(formTask.interfaceSisAf),
        moduloSisAf: Number(formTask.moduloSisAf),
        tipoTask: Number(formTask.tipoTask),
        responsavel: Number(formTask.responsavel),
        complexidade: Number(formTask.complexidade),
        reaproveitamentoCodigo: Number(formTask.reaproveitamentoCodigo),
        statusDesenvolvimento: Number(formTask.statusDesenvolvimento) - 1,
        dataEntrada: formTask.dataEntrada ? formTask.dataEntrada : null,
        dataFinalizacao: formTask.dataFinalizacao
          ? formTask.dataFinalizacao
          : null,
      };

      const response = await httpClient.patch(
        `/api/taskssisdaf/${fichaID}`,
        formToSend,
      );

      swalAtualizacao('Sucesso', response.data.message);
      fetchData(response.data.registro.id);
    } catch (error: any) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao atualizar dados', error);
      console.log(error.message);
    }
  };

  const handleDelete = async () => {
    const result = await swalDelete();
    if (!result) {
      return;
    }

    if (result) {
      try {
        await httpClient.delete(`/api/taskssisdaf/${fichaID}`);
        swalDeleteConfirm();
        navigate('/daf/maisopcoes/tasks');
      } catch (error) {
        if (isHttpError(error)) {
          swalErro(error.response?.data.message);
        }
        console.error('Erro ao excluir registro', error);
        swalErro('Não foi possível excluir o registro. Tente novamente.');
      }
    }
  };

  //Retorno
  return (
    <>
      <SubAbas>
        <StyledLink
          to="/daf/maisopcoes/tasks"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <FaArrowLeft />
        </StyledLink>
        <BarraSubAbas subAbas={subAbas} />
      </SubAbas>

      <ContainerConteudo>
        <WorkspaceFicha>
          <Log {...logs} entity="TB_TASK_SISAF" id={Number(fichaID)} />

          <BoxConteudo boxTitulo="Task" fechado>
            <CustomRow style={{ marginTop: '-15px' }}>
              <CustomCol width="250px">
                <SelectInput
                  name="interfaceSisAf"
                  options={interfaceSisaf}
                  label="Interface"
                  value={formTask.interfaceSisAf}
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              <CustomCol width="300px">
                <SelectInput
                  name="moduloSisAf"
                  options={moduloDaf}
                  label="Módulo"
                  value={formTask.moduloSisAf}
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              <CustomCol width="350px">
                <SelectInput
                  name="tipoTask"
                  options={tipoTask}
                  label="Tipo de Task"
                  value={formTask.tipoTask}
                  onChange={handleChange}
                  required
                />
              </CustomCol>

              <CustomCol width="200px">
                <Input
                  name="dataEntrada"
                  label="Data Início"
                  value={formTask.dataEntrada}
                  id="dataEntrada"
                  onChange={handleChange}
                  type="date"
                />
              </CustomCol>
              <CustomCol width="200px">
                <Input
                  name="dataFinalizacao"
                  label="Data Fim"
                  value={formTask.dataFinalizacao}
                  id="dataFinalizacao"
                  onChange={handleChange}
                  type="date"
                  readonly={isDataFimReadOnly}
                />
              </CustomCol>
              <CustomCol>
                <SelectInput
                  name="responsavel"
                  options={responsavelTask}
                  label="Responsável"
                  value={formTask.responsavel}
                  onChange={handleChange}
                  required
                />
              </CustomCol>
            </CustomRow>

            {/* Funcionalidade */}
            <CustomRow>
              <CustomCol>
                <Input
                  name="funcionalidade"
                  label="Funcionalidade"
                  value={formTask.funcionalidade}
                  id="funcionalidade"
                  onChange={handleChange}
                  required
                />
              </CustomCol>
            </CustomRow>

            {/* Descrição */}
            <CustomRow>
              <CustomCol>
                <Input
                  name="descricao"
                  label="Descrição"
                  value={formTask.descricao}
                  id="descricao"
                  onChange={handleChange}
                  type="textarea"
                  linhas={5}
                  required
                />
              </CustomCol>
            </CustomRow>

            {/* Classificação Técnica */}
            <CustomRow style={{ justifyContent: 'flex-start' }}>
              <CustomCol width="275px">
                <SelectInput
                  name="complexidade"
                  options={valoresZeroDez}
                  label="Nível de Complexidade"
                  value={formTask.complexidade}
                  onChange={handleChange}
                  style={nivelComplexidadeStyle}
                  required
                />
              </CustomCol>
              <CustomCol width="275px">
                <SelectInput
                  name="reaproveitamentoCodigo"
                  options={valoresZeroDezReaproveitamentoCodigo}
                  label="Reaproveitamento de Código?"
                  value={formTask.reaproveitamentoCodigo}
                  onChange={handleChange}
                  style={reaproveitamentoStyle}
                  required
                />
              </CustomCol>
              <CustomCol width="200px">
                <Input
                  name="level"
                  label="Level"
                  value={formTask.pontosFuncionalidade}
                  id="level"
                  onChange={handleChange}
                  style={levelStyle}
                  readonly
                />
              </CustomCol>
              <CustomCol width="275px">
                <SelectInput
                  name="statusDesenvolvimento"
                  options={valoresZeroDezStatus}
                  label="Status de Desenvolvimento"
                  value={formTask.statusDesenvolvimento}
                  onChange={handleChange}
                  style={statusDesenvolvimentoStyle}
                  required
                />
              </CustomCol>
              {/* <CustomCol width="200px">
                <Input
                  name="descricao"
                  label="Pontos Desenvolvidos"
                  value={formTask.pontosDesenvolvidos}
                  id="descricao"
                  onChange={handleChange}
                  style={{ textAlign: 'right' }}
                  readonly
                />
              </CustomCol> */}
            </CustomRow>
          </BoxConteudo>

          <BoxConteudo boxTitulo="Observações" fechado>
            <CustomRow style={{ marginTop: '-15px' }}>
              <CustomCol>
                <Input
                  id="observacoes"
                  name="observacoes"
                  value={formTask.observacoes}
                  label=""
                  type="textarea"
                  onChange={handleChange}
                  linhas={5}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>
        </WorkspaceFicha>
      </ContainerConteudo>

      <BarraInferiorBotoes>
        {fichaID !== 'undefined' ? (
          <WorkspaceBotoes
            delete
            onClickDelete={handleDelete}
            save
            onClickSave={handleUpdate}
          />
        ) : (
          <WorkspaceBotoes save onClickSave={handleCreate} />
        )}
      </BarraInferiorBotoes>
    </>
  );
}
